import axios from 'axios'
import apiSetting from '@/api/apiSetting'
import apiTools from '@/api/apiTools'
import store from '@/store'

/**
 * 获取请求参数
 */
function getConfig(options = {}, annex = {}) {
  const config = {
    timeout: apiSetting.timeOut, ...options,
    headers: {
      token: store.state.user.token || '',
      'Content-Type': 'application/json', ...(options.headers || {})
    }
  }
  if (annex.disableToken) {
    delete config.headers.token
  }
  return config
}

/**
 * 创建网络连接并定义拦截规则
 */
function createService(options = {}, annex = {}) {
  const service = axios.create()
  // 请求拦截
  service.interceptors.request.use(config => config, error => Promise.reject(error))
  // 响应拦截
  service.interceptors.response.use(res => res.data, error => {
    apiTools.toast(annex, apiTools.getStatusErrorMessage(error.response ? error.response.status : -1))
    return Promise.reject(error)
  })
  // 处理返回信息
  return new Promise((resolve, reject) => {
    service(getConfig(options, annex)).then(res => {
      const codeKey = apiTools.getCodeKey(res)
      if (annex.disableHandle || !codeKey) {
        resolve(res)
        return
      }
      if (apiTools.isSuccess(res[codeKey])) {
        const key = annex.resultKey
        resolve(key ? res[key] : res)
        return
      }
      if (apiTools.tokenExpired(res[codeKey]) && !annex.disableToken) {
        if (!annex.disableRefreshToken) {
          resolve(apiTools.updateToken(options, annex))
        } else {
          apiTools.showTokenError()
        }
      } else {
        const message = apiTools.getResultErrorMessage(res[codeKey], res)
        apiTools.toast(annex, message)
        reject(new Error(message))
      }
    }).catch(error => reject(error))
  })
}

/**
 * 统一处理网络请求参数
 */
function handleRequest(baseURL, url, method, custom = {}) {
  //对自定义参数进行区分成axios原有参数和内置参数两种
  const options = {}, annex = {}
  for (let customKey in custom) {
    (apiSetting.customParams.includes(customKey) ? annex : options)[customKey] = custom[customKey]
  }
  //创建网络请求
  return createService({
    baseURL,
    url,
    method, ...options
  }, annex)
}

/**
 * 获取请求的request
 * @param baseURL 基本url
 * @param resultKey 返回对象的key值，如果为空则返回所有内容，不为空则返回对应内容（如果存在disableHandle则该字段无效）
 */
export default function getRequest(baseURL = '', resultKey = '') {
  return {
    /**
     * @param url 目标url
     * @param params 目标params
     * @param custom 可加参数为：resultKey、disableHandle(返回原始数据)、disableToken(不传token)、disableToast(不提示错误)、axios所有配置参数
     */
    get(url, params, custom = {}) {
      return handleRequest(baseURL, url, 'get', {
        params: params || {},
        resultKey, ...custom
      })
    },
    post(url, data, custom = {}) {
      return handleRequest(baseURL, url, 'post', {
        data: data || {},
        resultKey, ...custom
      })
    },
    put(url, data, custom = {}) {
      return handleRequest(baseURL, url, 'put', {
        data: data || {},
        resultKey, ...custom
      })
    },
    delete(url, params, custom = {}) {
      return handleRequest(baseURL, url, 'delete', {
        params: params || {},
        resultKey, ...custom
      })
    },
    service(options, annex) {
      return createService(options, annex)
    }
  }
}
